(function ($) {
  'use strict';

  /**
   * Culture - Detail/Tracks - v1
   */
  var cultureDetailArticleV1 = {
    formatter: $('.culture-detail-tracks-v1')
  };

  Drupal.behaviors.cultureDetailArticleV1 = {
    get: function (key) {
      return cultureDetailArticleV1[key];
    },

    set: function (key, val) {
      cultureDetailArticleV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        if (thisFormatter.hasClass('has-gallery')) {
          var gallery = thisFormatter.find('.culture-detail__article-content__body-gallery');
          var mainImage = gallery.find('.culture-detail__article-content__body-gallery-main');

          if (typeof mainImage != 'undefined') {
            var slide = gallery.find('.culture-detail__article-content__body-gallery-slide');

            slide.once().click(function () {
              var thumb = $(this).find('img');
              var src = thumb.attr('src');

              if (mainImage.is(':visible')) {
                mainImage.find('img').fadeOut(300, function () {
                  $(this).attr('src', src).fadeIn(300);
                });
              }
            });
          }
        }
      });

      // share
      var headlinePullQuote = $('.culture-detail__header-title').html().trim();
      // twitter
      var twitter_url = encodeURIComponent(window.location.href);
      var twitter_full = 'https://twitter.com/share/?&text=' + encodeURIComponent(headlinePullQuote) + '&url=' + twitter_url;

      $('.culture__social-link--twitter').on('click', function () {
        window.open(twitter_full, 'tweet', 'width=790,height=460');
      });

      // email
      var email_subject = site.translations.culture.check_out_all_the_articles;
      var email_body = encodeURIComponent(headlinePullQuote + '\n' + window.location.href + '\n\n' + site.translations.culture.want_to_see_what_else_is_new + '\n\n' + site.translations.culture.sign_up + '\nhttp://' + window.location.host + '/email_signup/email_signup.tmpl');
      var email_full = 'mailto:?subject=' + email_subject + '&body=' + email_body;

      $('.culture__social-link--email').on('click', function () {
        window.location.href = email_full;
      });

      // facebook
      $("meta[name='og:image']").attr('content', window.location.origin + $('.culture-detail__article-image').attr('src'));
      var facebook_url = encodeURIComponent(window.location.href);
      var facebook_full = 'https://www.facebook.com/sharer/sharer.php?u=' + facebook_url;

      $('.culture__social-link--facebook').on('click', function () {
        window.open(facebook_full, 'facebook_share', 'width=790,height=460');
      });
    }
  };
})(jQuery);
